export default {
  JPEG: 'jpeg',
  JPG: 'jpg',
  PNG: 'png',
  HEIC: 'heic',
  PDF: 'pdf',
  HEIF: 'heif',
  C_HEIC: 'HEIC',
  C_HEIF: 'HEIF',
  MP4: 'mp4',
  STL: 'stl',

  // Adding video formats
  MOV: 'mov',
  AVI: 'avi',
  MKV: 'mkv',
  WEBM: 'webm',
  FLV: 'flv',
  WMV: 'wmv',
  GP3: '3gp',
} as const
